@if (material) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row g-2">
      <div class="form-group col-sm-6 col-md-4">
        <label for="accessibilityFeatures">
          {{ "forms.educationalResource.extendedDetails.accessibility.inputs.features.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.accessibility.inputs.features.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="accessibilityFeatures"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="value"
          id="accessibilityFeatures"
          labelForId="accessibilityFeatures"
        formControlName="accessibilityFeatures"></ng-select>
        <label>
          <a href="{{ accessibilityLink }}" rel="noopener" target="_blank">
            {{ "accessibility.linkToMoreInformation" | translate }}
          </a>
        </label>
      </div>
      <!--/accessibility features-->
      <div class="form-group col-sm-6 col-md-4">
        <label for="accessibilityHazards">
          {{ "forms.educationalResource.extendedDetails.accessibility.inputs.hazards.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.accessibility.inputs.hazards.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="accessibilityHazards"
          [multiple]="true"
          [closeOnSelect]="false"
          bindLabel="value"
          id="accessibilityHazards"
          labelForId="accessibilityHazards"
        formControlName="accessibilityHazards"></ng-select>
      </div>
      <!--/accessibility hazards-->
      <div class="form-group col-sm-6 col-md-4 typical-age-range">
        <span class="group-label">
          {{ "forms.educationalResource.extendedDetails.typicalAgeRange.label" | translate }}
        </span>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.typicalAgeRange.tooltip" variant="help"></app-tooltip-button>
        <div class="row flex-nowrap align-items-center g-2 typical-age-range-row" formGroupName="typicalAgeRange">
          <div class="col">
            <label for="typicalAgeRangeMin" class="visually-hidden">
              {{ "forms.educationalResource.extendedDetails.typicalAgeRange.label" | translate }} (min)
            </label>
            <input
              type="text"
              id="typicalAgeRangeMin"
              class="form-control"
              formControlName="typicalAgeRangeMin"
              inputmode="numeric"
            [ngClass]="{
              'is-invalid':
                typicalAgeRangeMinCtrl.invalid &&
                (typicalAgeRangeMinCtrl.dirty || typicalAgeRangeMinCtrl.touched || submitted)
            }" />
            @if (
              typicalAgeRangeMinCtrl.invalid &&
              (typicalAgeRangeMinCtrl.dirty || typicalAgeRangeMinCtrl.touched || submitted)
              ) {
              <div
                class="invalid-feedback">
                @if (typicalAgeRangeMinCtrl.errors.min) {
                  <div>{{ "forms.common.min" | translate }} 0</div>
                }
                @if (typicalAgeRangeMinCtrl.errors.pattern) {
                  <div>{{ "forms.common.pattern.numeric" | translate }}</div>
                }
                @if (typicalAgeRangeMinCtrl.errors.maxlength) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength:
                    typicalAgeRangeMinCtrl.errors.maxlength.requiredLength } }}
                  </div>
                }
              </div>
            }
          </div>
          <div class="col-auto">&ndash;</div>
          <div class="col">
            <label for="typicalAgeRangeMax" class="visually-hidden">
              {{ "forms.educationalResource.extendedDetails.typicalAgeRange.label" | translate }} (max)
            </label>
            <input
              type="text"
              id="typicalAgeRangeMax"
              class="form-control"
              formControlName="typicalAgeRangeMax"
              inputmode="numeric"
            [ngClass]="{
              'is-invalid':
                typicalAgeRangeMaxCtrl.invalid &&
                (typicalAgeRangeMaxCtrl.dirty || typicalAgeRangeMaxCtrl.touched || submitted)
            }" />
            @if (
              typicalAgeRangeMaxCtrl.invalid &&
              (typicalAgeRangeMaxCtrl.dirty || typicalAgeRangeMaxCtrl.touched || submitted)
              ) {
              <div
                class="invalid-feedback">
                @if (typicalAgeRangeMaxCtrl.errors.min) {
                  <div>{{ "forms.common.min" | translate }} 0</div>
                }
                @if (typicalAgeRangeMaxCtrl.errors.pattern) {
                  <div>{{ "forms.common.pattern.numeric" | translate }}</div>
                }
                @if (typicalAgeRangeMaxCtrl.errors.maxlength) {
                  <div>
                    {{ "forms.errors.common.maxLength" | translate: { maxLength:
                    typicalAgeRangeMaxCtrl.errors.maxlength.requiredLength } }}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <!--/typical age range-->
      <div class="form-group col-sm-6 col-md-4">
        <label for="timeRequired">{{ "forms.educationalResource.extendedDetails.timeRequired.label" | translate }}</label>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.timeRequired.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="timeRequired"
          formControlName="timeRequired"
        [ngClass]="{
          'is-invalid': timeRequiredCtrl.invalid && (timeRequiredCtrl.dirty || timeRequiredCtrl.touched || submitted)
        }" />
        @if (timeRequiredCtrl.invalid && (timeRequiredCtrl.dirty || timeRequiredCtrl.touched || submitted)) {
          <div
            class="invalid-feedback">
            @if (timeRequiredCtrl.errors.invalidCharacters) {
              <div>
                {{ "forms.errors.textInput.characters" | translate }}
              </div>
            }
            @if (timeRequiredCtrl.errors.maxlength) {
              <div>
                {{ "forms.errors.common.maxLength" | translate: { maxLength: timeRequiredCtrl.errors.maxlength.requiredLength
                } }}
              </div>
            }
          </div>
        }
        <small id="timeRequired-help" class="form-text text-muted">
          {{ "forms.helpTexts.timeRequired" | translate }}
        </small>
      </div>
      <!--/time required-->
      <div class="form-group col-sm-6 col-md-4">
        <label for="publisher">{{ "forms.educationalResource.extendedDetails.publisher.label" | translate }}</label>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.publisher.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          [items]="[]"
          [multiple]="true"
          [addTag]="addCustomItem"
          bindLabel="value"
          id="publisher"
          labelForId="publisher"
          formControlName="publisher"
        aria-describedby="publisher-help"></ng-select>
        <small id="publisher-help" class="form-text text-muted">{{ "forms.helpTexts.multipleItems" | translate }}</small>
      </div>
      <!--/publisher-->
      <div class="form-group col-sm-6 col-md-4">
        <label for="expires">{{ "forms.educationalResource.extendedDetails.expires.label" | translate }}</label>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.expires.tooltip" variant="help"></app-tooltip-button>
        <input
          type="text"
          class="form-control"
          id="expires"
          formControlName="expires"
          bsDatepicker
          [bsConfig]="{ dateInputFormat: 'DD.MM.YYYY' }" />
      </div>
      <!--/expires-->
      <div class="form-group col-sm-6 col-md-4">
        <label for="prerequisites">
          {{ "forms.educationalResource.extendedDetails.prerequisites.label" | translate }}
        </label>
        <app-tooltip-button key="forms.educationalResource.extendedDetails.prerequisites.tooltip" variant="help"></app-tooltip-button>
        <ng-select
          aoeAlignmentTagDedupe
          [items]="[]"
          [multiple]="true"
          [addTag]="addPrerequisites"
          bindLabel="targetName"
          id="prerequisites"
          labelForId="prerequisites"
          formControlName="prerequisites"
        aria-describedby="prerequisites-help"></ng-select>
        <small id="prerequisites-help" class="form-text text-muted">
          {{ "forms.helpTexts.multipleItems" | translate }}
        </small>
      </div>
      <!--/prerequisites-->
    </div>
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">{{ "forms.common.previous" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
      </div>
    </div>
  </form>
}
